import { post } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

const exploJwtRequestSchema = z.object({
  data: z.object({
    attributes: z.object({
      workplaceId: z.string(),
      embedId: z.string(),
    }),
  }),
});

const exploJwtResponseSchema = z.object({
  data: z.object({
    attributes: z.object({
      jwt: z.string(),
    }),
  }),
});

export type ExploJwtResponseType = z.infer<typeof exploJwtResponseSchema>;
export type ExploJwtRequestType = z.infer<typeof exploJwtRequestSchema>;

export function useExploToken(
  options: UseMutationOptions<ExploJwtResponseType, AxiosError, ExploJwtRequestType> = {}
) {
  return useMutation({
    mutationFn: async (data: ExploJwtRequestType) => {
      const response = await post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/explo-service/jwt`,
        data,
        requestSchema: exploJwtRequestSchema,
        responseSchema: exploJwtResponseSchema,
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.EXPLO_JWT_TOKEN_FAILURE,
    },
    ...options,
  });
}
